import { LocationPageTemplate } from "@/components/LocationPageTemplate";

export default function Neukoelln() {
  return (
    <LocationPageTemplate
      page={{
        location: "Neukölln",
        locationSlug: "neukoelln",
        keyword: "Haushaltsauflösung Neukölln",
        metaTitle:
          "Haushaltsauflösung Neukölln | Festpreis & Termin in 48h | MIROS",
        metaDesc:
          "Professionelle Haushaltsauflösung in Berlin Neukölln. Schnelle, diskrete und besenreine Haushaltsauflösung zum Festpreis. Kostenlose Besichtigung!",
        heroSub:
          "Ihre zuverlässige Haushaltsauflösung in Neukölln – schnell, diskret und besenrein zum Festpreis.",
        heroImg:
          "https://assets.cdn.filesafe.space/RcAk4NqqJiBX4hgBLewG/media/69909eeb899b88c4298a9a43.jpg",
        localIntro: (
          <>
            <p>
              Neukölln ist einer der am dichtesten besiedelten Bezirke Berlins
              und stellt bei Entrümpelungen oft besondere logistische
              Anforderungen. Besonders im Norden des Bezirks (Nord-Neukölln)
              prägen klassische Berliner Altbauten mit oft engen Treppenhäusern,
              Hinterhöfen und einer angespannten Parkplatzsituation das Bild.
            </p>
            <p>
              In den südlicheren Ortsteilen wie Britz, Buckow oder Rudow ändert
              sich das Stadtbild hin zu Einfamilienhäusern und
              Reihenhaussiedlungen, wo oft komplette Grundstücke inklusive
              Kellern und Garagen geräumt werden müssen.
            </p>
            <p>
              Wir kennen die unterschiedlichen Strukturen in Neukölln genau.
              Egal ob es sich um eine Wohnung im 5. Stock ohne Aufzug am
              Hermannplatz handelt oder um ein Haus in Rudow – wir bringen die
              nötige Erfahrung und das passende Team mit, um die Räumung schnell
              und professionell durchzuführen.
            </p>
          </>
        ),
        trustText:
          "Ob in einer Altbauwohnung im Reuterkiez oder einem Reihenhaus in Buckow – wir nehmen Ihnen die schwere Arbeit ab und stehen Ihnen diskret zur Seite.",
        trustQuote:
          "Das Team hat unsere Wohnung in Nord-Neukölln trotz des engen Treppenhauses super schnell geräumt. Sehr zu empfehlen!",
        challengesText: (
          <>
            <p>
              Die größte Herausforderung im Norden Neuköllns ist oft die
              Logistik. Wir kümmern uns zuverlässig um die Einrichtung von
              Halteverbotszonen, um kurze Wege beim Abtransport zu sichern. Bei
              engen Hinterhöfen oder Treppenhäusern arbeiten wir besonders
              vorsichtig, um Schäden am Gebäude zu vermeiden.
            </p>
            <p>
              Wir legen großen Wert auf Diskretion und eine zügige Arbeitsweise,
              um die Nachbarschaft in den dicht besiedelten Kiezen so wenig wie
              möglich zu stören. Die fachgerechte Entsorgung auf den Berliner
              Recyclinghöfen ist dabei immer inklusive.
            </p>
          </>
        ),
        reviews: [
          {
            text: "Pünktlich, schnell und ein fairer Festpreis. Die Wohnung wurde komplett besenrein übergeben.",
            author: "Kunde aus Britz",
          },
          {
            text: "Toller Service! Die Mitarbeiter waren sehr freundlich und haben sehr sauber gearbeitet.",
            author: "Kundin aus Rudow",
          },
          {
            text: "Die Räumung der Altbauwohnung lief absolut reibungslos. Ich musste mich um nichts kümmern.",
            author: "Familie aus Nord-Neukölln",
          },
        ],
        neighbors: [
          { name: "Treptow-Köpenick", slug: "treptow-koepenick" },
          { name: "Berlin", slug: "berlin" },
          { name: "Steglitz-Zehlendorf", slug: "steglitz-zehlendorf" },
        ],
        faqs: [
          {
            q: "Beantragen Sie die Halteverbotszone in Neukölln selbst?",
            a: "Ja, wir kümmern uns um die komplette Abwicklung mit dem Bezirksamt und stellen die Schilder rechtzeitig auf.",
          },
          {
            q: "Räumen Sie auch Wohnungen im Hinterhaus ohne Aufzug?",
            a: "Selbstverständlich. Wir räumen auch aus oberen Stockwerken ohne Aufzug und bringen dafür das nötige Personal mit.",
          },
          {
            q: "Was kostet eine Haushaltsauflösung in Neukölln?",
            a: "Die Kosten hängen vom Aufwand ab. Nach einer kostenlosen Besichtigung erhalten Sie von uns einen verbindlichen Festpreis.",
          },
          {
            q: "Wie schnell können Sie mit der Räumung beginnen?",
            a: "Oft können wir nach der Besichtigung schon innerhalb weniger Tage mit der eigentlichen Entrümpelung starten.",
          },
        ],
      }}
    />
  );
}
